import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { withRouter } from 'react-router';
import RouterPropTypes from 'react-router-prop-types';
import { Link } from 'react-router-dom';
import { Alert, Button } from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';

import globalTranslations from '../../../i18n/globalTranslations';
import Paths from '../../../types/Paths';
import RouteService from '../../../services/RouteService';
import CustomerUserStore from '../../../store/CustomerUserStore';
import { modelOf } from '../../../prop-types';
import ContentForState from '../../loader/ContentForState';
import HelperNavigation from '../../common/HelperNavigation';
import PageTitle from '../../common/PageTitle';
import generatePath from '../../../util/generatePath';
import UnexpectedError from '../../loader/UnexpectedError';
import UserList from '../../user/UserList';
import SEOTitle from '../../head/SEOTitle';
import AccountStore from '../../../store/AccountStore';
import RequestState from '../../../types/RequestState';

@observer
export class MyAccountUserList extends Component {
  state = {
    removeError: null,
    requestId: 0,
    listState: RequestState.NONE,
    paymentAmount: [],
    paymentInProgress: false
  };

  componentDidMount() {
    const { customerUserStore } = this.props;
    this.setState({
      listState: RequestState.LOADING
    });
    customerUserStore
      .loadUsers()
      .then(() => {
        this.setState({
          listState: RequestState.LOADED
        });
      })
      .catch(() => {
        this.setState({
          listState: RequestState.ERROR
        });
      });
  }

  getBreadcrumbsPath = () => {
    const { intl, routeService } = this.props;
    return routeService.transformBreadCrumbs([
      {
        text: intl.formatMessage(globalTranslations.myAccount),
        url: Paths.MyAccount
      },
      {
        text: intl.formatMessage(globalTranslations.userListTitle),
        url: Paths.MyAccountUserList
      }
    ]);
  };

  removeUser = (id) => {
    const { customerUserStore } = this.props;
    customerUserStore
      .removeUser(id)
      .then(() => {
        customerUserStore.loadUsers();
        this.setState({ removeError: null });
      })
      .catch((error) =>
        this.setState({
          removeError: error,
          requestId: this.state.requestId + 1
        })
      );
  };

  navigateToUser = (id) => {
    const { routeService } = this.props;
    const path = routeService.getPath(
      generatePath(Paths.MyAccountUser, { id })
    );
    return this.props.history.push(path);
  };

  renderUserList = () => {
    const { customerUserStore } = this.props;
    return (
      <UserList
        users={customerUserStore.userArray}
        onEditClick={this.navigateToUser}
        onRemoveClick={this.removeUser}
        onPayment={() => null}
        showBalance={false}
      />
    );
  };

  renderError = () => {
    const { removeError, requestId } = this.state;
    const errors = _.get(removeError, 'response.data.errors');
    return errors ? (
      <Alert
        className="MyAccountUserList__errors"
        color="danger"
        key={requestId}
      >
        {Object.values(removeError.response.data.errors).map((message) => (
          <div key={message}>{message}</div>
        ))}
      </Alert>
    ) : (
      <UnexpectedError />
    );
  };

  render() {
    const { customerUserStore, routeService } = this.props;
    const { removeError } = this.state;

    return (
      <div className="MyAccountUserList">
        <SEOTitle title={globalTranslations.userListTitle} />
        <HelperNavigation breadcrumbsPath={this.getBreadcrumbsPath()} />
        <PageTitle>
          <FormattedMessage {...globalTranslations.userListTitle} />
        </PageTitle>
        <Link to={routeService.getPath(Paths.MyAccountUserNew)}>
          <Button color="primary" className="MyAccountUserList__add-new-button">
            <FormattedMessage {...globalTranslations.addNewUserTitle} />
          </Button>
        </Link>
        {removeError && this.renderError()}
        <ContentForState
          state={this.state.listState}
          error={customerUserStore.lastError}
          forLoaded={() => this.renderUserList()}
        />
      </div>
    );
  }
}

MyAccountUserList.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  customerUserStore: modelOf(CustomerUserStore).isRequired,
  history: RouterPropTypes.history.isRequired,
  intl: intlShape.isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired
};

export default injectIntl(
  inject('customerUserStore', 'routeService', 'accountStore')(
    withRouter(MyAccountUserList)
  )
);



// WEBPACK FOOTER //
// ./src/components/my-account/MyAccountUserList/index.jsx